"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getStarRatingUtilityClass = getStarRatingUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getStarRatingUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriStarRating', slot);
}
const starRatingClasses = (0, _base.generateUtilityClasses)('MuiOriStarRating', ['root', 'star', 'textRating', 'emptyStar', 'fullStar', 'halfStar']);
var _default = exports.default = starRatingClasses;
